<template>
  <div class="slo-nav-account--wrapper">
    <a v-if="showUserDetail" href="/marketplace" class="nav-link--account flex items-center justify-center gap-sm">
      <SloIcon name="User" />
      <span v-if="authenticated && user.firstName">
        {{ 'Hello' | t }}, {{ firstNameDisplay }}
      </span>
      <span v-else>
        {{ 'My Account' | t }}
      </span>
    </a>
    <a
      v-if="showCartButton"
      href="/marketplace/cart"
      class="slo-nav-account flex items-center justify-center gap-sm p-0 border-none"
      :aria-label="'Cart Trigger and Total: ' + cartTotalUnitCount | t"
    >
      <SloIcon name="CartShopping" />
      <span
        :class="{
          'slo-cart-quantity': true,
          'slo-cart-quantity--active': cartTotalUnitCount > 0
        }"
      >
        {{ cartTotalUnitCount > 99 ? '99+' : cartTotalUnitCount }}
      </span>
    </a>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import t from '../../js/main/i18n';
import SloIcon from './SloIcon.vue';

export default {
  name: 'SloNavAccount',
  components: {
    SloIcon
  },
  filters: {
    t
  },
  computed: {
    ...mapGetters('auth', ['authenticated', 'user']),
    ...mapGetters('marketplace', ['cartTotalUnitCount']),
    firstNameDisplay() {
      return this.user?.firstName ? this.user.firstName.replace(/(.{15})..+/, '$1…') : '';
    }
  },
  props: {
    showUserDetail: {type: Boolean, default: false},
    showCartButton: {type: Boolean, default: false}
  }
};
</script>

<style lang="scss" scoped>
@import '../../scss/variables';
@import '../../scss/system';

.slo-nav-account {
  position: relative;
  background-color: transparent;
  color: #9ca3af;

  &:hover {
    color: $color-gray-700;
  }

  & > :deep(.slo-icon), :deep(.slo-icon > svg) {
    width: 20px;
    height: 20px;

    @media (min-width: 992px) {
      width: 16px;
      height: 16px;
    }
  }

  @media (min-width: 992px) {
    color: $color-gray-500;

    &:hover {
      color: $color-gray-700;
    }
  }

  &--wrapper {
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 24px;
    max-height: 20px;

    @media (min-width: 992px) {
      justify-content: center;
      max-width: none;
    }
  }
}

.nav-link--account {
  color: $color-gray-700;

  :deep(.slo-icon) {
    display: none;
  }

  @media (min-width: 992px) and (max-width: 1199px) {
    span {
      display: none;
    }
  }

  @media (min-width: 1024px) {
    :deep(.slo-icon) {
      display: inline-flex;
    }

    :deep(svg) {
      color: $color-gray-500;
    }

    &:hover {
      :deep(svg) {
        color: $color-gray-700;
      }
    }
  }
}

.slo-cart-quantity {
  display: none;
  color: $color-gray-700;

  &--active {
    display: flex;
    align-items: center;
    justify-content: center;
    color: $color-gray-900;
  }
}
</style>
